import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

export const PRODUCT_DETAILS_SUCCESS = 'PRODUCT_DETAILS_SUCCESS';
export const PRODUCT_DETAILS_LOADING = 'PRODUCT_DETAILS_LOADING';

const { product: { getProduct } } = apiUrls;


export const getProducteDetails = () => async (dispatch) => {
  try {

    const data = await REQUEST(getProduct);
    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      data,
    })
  } catch (e) {

    dispatch({
      type: PRODUCT_DETAILS_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      }
    })
  }

}

export const handleLoader = isLoading => (dispatch) => {
  dispatch({
    type: PRODUCT_DETAILS_LOADING,
    isLoading
  })
}
